import playbookService from "@/services/playbook.service"
import { utils } from "@/store/helpers"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

const initialState = {
  playbooks: [],
  tags: []
}

export const playbook = {
  namespaced: true,
  state: initialState,
  actions: {
    PLAYBOOK: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.NEW_PLAYBOOK_ADDED, data)
      }
    },

    "PLAYBOOK.UPDATE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        if (data.is_removed) {
          this.$emitter.emit(ALL_EMITTERS.PLAYBOOK_REMOVED, data)
        } else {
          this.$emitter.emit(ALL_EMITTERS.PLAYBOOK_UPDATED, data)
        }
      }
    },
    updatePlaybookExecutionStep: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_PLAYBOOK_EXECUTION_STEP, data)
      }
    },
    async getTags({ commit }) {
      return await playbookService.getTags({ page_size: 100 }).then(
        (response) => {
          commit("setTags", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    getPlaybook({ commit }, id) {
      return playbookService.getPlaybook(id).then(
        (response) => {
          commit("addPlaybook", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    createPlaybook({ commit }, data) {
      return playbookService
        .createPlaybook(data)
        .then(
          (response) => {
            commit("createPlaybook", response.data)
            return response.data
          },
          (error) => {
            return Promise.reject(error?.response?.data)
          }
        )
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    updatePlaybook({ commit }, { id, data }) {
      return playbookService
        .updatePlaybook(id, data)
        .then(
          (response) => {
            commit("updatePlaybook", response.data)
            return response.data
          },
          (error) => {
            return Promise.reject(error?.response?.data)
          }
        )
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    removePlaybook({ commit }, id) {
      return playbookService.deletePlaybook(id).then(
        (response) => {
          commit("removePlaybook", id)
          return response.data
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    triggerPlaybookExecution: {
      async handler({ commit }, { id, data }) {
        return playbookService
          .triggerPlaybookExecution(id, data)
          .then(
            (response) => {
              return response.data
            },
            (error) => {
              return Promise.reject(error?.response?.data)
            }
          )
          .catch((error) => {
            return Promise.reject(error)
          })
      }

    },
    getPlaybooks({ commit }) {
      return playbookService.getPlaybooks({ page_size: 100 }).then(
        (response) => {
          commit("setPlaybooks", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    }
  },
  mutations: {
    setPlaybooks(state, playbooks) {
      state.playbooks = playbooks
      state.playbooks = utils.clone(playbooks)
    },
    addPlaybook(state, playbook) {
      state.playbooks.push(playbook)
    },
    updatePlaybook(state, data) {
      state.playbooks = utils.replaceItem(state.playbooks, data)
    },
    createPlaybook(state, data) {
      state.playbooks = [data].concat(state.playbooks)
      state.playbooks.push(data)
    },
    removePlaybook(state, id) {
      state.playbooks = state.playbooks.filter((g) => g.id !== id)
      state.playbooks = state.playbooks.filter((g) => g.id !== id)
    },
    setTags(state, tags) {
      state.tags = tags
    }
  }
}
